import styled from 'styled-components';
import { typography } from '../../../../stories/foundation';

export const OtherReasonInputGroup = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 8px;
  flex-direction: column;
`;
